import * as imageClientAPI from '@wix/image-client-api/dist/imageClientSDK';
import { COVER_MAX_SIZE, isValidAlbumForEnablingStore } from '../consts/uou';
var TRANSPARENT_IMAGE_URL = 'https://static.wixstatic.com/media/60cca8_c6fad025c40a4acb840f458b3b6f5f5b~mv2.png/v1/fit/w_297,h_206/60cca8_c6fad025c40a4acb840f458b3b6f5f5b~mv2.png';
var ImageClientApiService = /** @class */ (function () {
    function ImageClientApiService() {
        var _this = this;
        this.DEFAULT_WATERMARK_DATA = {
            position: 9,
            size: 40,
            opacity: 40,
            imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
            imageRatio: 1.42517815,
        };
        this.getWatermarkStr = function (watermark) {
            return "".concat(watermark.imageUrl, "-").concat(watermark.opacity, "-").concat(watermark.position, "-").concat(watermark.size);
        };
        this.getImageItemUrl = function (item, _a) {
            var _b = _a === void 0 ? {} : _a, targetWidth = _b.targetWidth, targetHeight = _b.targetHeight;
            var options = {};
            if (item.photoMetadata.focalPoint) {
                options = {
                    focalPoint: {
                        x: (item.photoMetadata.focalPoint.x || 0.5) * 100,
                        y: (item.photoMetadata.focalPoint.y || 0.5) * 100,
                    },
                };
            }
            return item
                ? imageClientAPI.getScaleToFillImageURL("media/".concat(item.name), item.photoMetadata.width, item.photoMetadata.height, targetWidth || item.photoMetadata.width, targetHeight || item.photoMetadata.height, options)
                : TRANSPARENT_IMAGE_URL;
        };
        this.formatImageUrlToCodeFormat = function (item, watermarkStr) {
            var itemWidth = item.photoMetadata ? item.photoMetadata.width : 0;
            var itemHeight = item.photoMetadata ? item.photoMetadata.height : 0;
            return ("wix:image://v1/".concat(item.name, "/").concat(item.name, "#originWidth=").concat(itemWidth, "&originHeight=").concat(itemHeight) +
                (watermarkStr ? "&watermark=".concat(watermarkStr) : ''));
        };
        this.getWixCodeImageWithWatermark = function (item, watermark) {
            var watermarkStr;
            if (watermark) {
                watermarkStr = _this.getWatermarkStr(watermark);
            }
            return _this.formatImageUrlToCodeFormat(item, watermarkStr);
        };
        this.getImageItemUrlWithWatermark = function (item, watermark, maxSize) {
            var _a = getImageMaxDimensions(item, maxSize), targetWidth = _a.targetWidth, targetHeight = _a.targetHeight;
            var itemUrl = _this.getImageItemUrl(item, { targetWidth: targetWidth, targetHeight: targetHeight });
            itemUrl = itemUrl.substr(0, itemUrl.lastIndexOf('.')) + '.webp';
            if (item && item.isSecure && itemUrl) {
                var token = item.imageToken || item.token;
                if (token) {
                    return itemUrl + '?token=' + token;
                }
                return itemUrl.replace(/\/([^\/]*)$/, ',wm_' +
                    _this.getWatermarkStr(watermark || _this.DEFAULT_WATERMARK_DATA) +
                    '/$1');
            }
            return itemUrl;
        };
        this.getCoverUrl = function (albumData, _a) {
            var cover = _a.cover, maxSize = _a.maxSize;
            if (!isValidAlbumForEnablingStore(albumData)) {
                cover.isSecure = false;
                return (_this.getImageItemUrlWithWatermark(cover, albumData.watermark, maxSize) || cover.mediaUrl);
            }
            else if (cover && cover.photoMetadata) {
                return (_this.getImageItemUrlWithWatermark(cover, albumData.watermark, maxSize) || cover.mediaUrl);
            }
            else if (cover) {
                return cover.thumbnail;
            }
            else {
                return TRANSPARENT_IMAGE_URL;
            }
        };
    }
    return ImageClientApiService;
}());
export var getImageMaxDimensions = function (image, maxSize) {
    var MAX_SIZE = (maxSize && Math.max(maxSize, 1000)) || COVER_MAX_SIZE;
    var ratio = image.photoMetadata
        ? image.photoMetadata.width / image.photoMetadata.height
        : 0;
    var targetWidth, targetHeight;
    if (ratio < 1) {
        targetHeight = MAX_SIZE;
        targetWidth = Math.floor(MAX_SIZE / ratio);
    }
    else {
        targetHeight = Math.floor(MAX_SIZE / ratio);
        targetWidth = MAX_SIZE;
    }
    return { targetWidth: targetWidth, targetHeight: targetHeight };
};
export default new ImageClientApiService();
//# sourceMappingURL=imageClientService.js.map